import { ReportSpecialList } from './ReportSpecialList';

export default ReportSpecialList;
